
const module = {
    namespaced: true,
    state: () => ({
        formData: {
            name:null,
            surname:null,
            birthdate:null,
            email:null,
            mobile_tel:null,
            city_id:null,
            district_id:null,
            school:null,
            campus_id:null,
            national_id:null,
        },
    }),
    getters: {
        getFormData(state) {
            return state.formData;
        },
    },
    mutations: {
        setFormData(state, formData) {
            state.formData = formData;
        },
    },
    actions: {
        setFormData({commit},data) {
            commit('setFormData',data)
        },
    }
}

export default module;
